module.exports = "/_next/static/images/postmates-cd6ba4286e809a3cdab75a5ca796b39a.png";